import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import { EMDASH } from 'Shared/utils';
import { BaseProps, Label, LabelProps, TextInputProps } from '..';
import styles from './styles.module.css';
import { Asset, WarningIcon } from '@clearcover/atlas';

export type ReadOnlyPropsType = {
  name?: string;
  label: string;
  value?: any;
  tooltip?: LabelProps['tooltip'];
  tooltipPosition?: LabelProps['tooltipPosition'];
  sizeVariant?: TextInputProps['sizeVariant'];
  options?: BaseProps['options'];
  className?: string;
  errorMessage?: string;
  tooltipLabel?: React.ReactNode;
  tooltipClassName?: string;
  children?: React.ReactNode;
  displayAsEmpty?: boolean;
};

export const ReadOnly: FC<ReadOnlyPropsType> = ({
  name,
  value,
  options,
  label,
  tooltip,
  tooltipPosition,
  sizeVariant = 'medium',
  className,
  errorMessage,
  tooltipLabel,
  tooltipClassName,
  displayAsEmpty,
}) => {
  const inputCss = classNames('fs-mask', {
    [styles.large]: sizeVariant === 'large',
    [styles.medium]: sizeVariant === 'medium',
    [styles.small]: sizeVariant === 'small',
  });

  const displayValue = useMemo(() => {
    if (displayAsEmpty) return '';

    return (options ? options[value] ?? value : value) || EMDASH;
  }, [options, value, displayAsEmpty]);

  return (
    <div
      className={classNames(styles.container, className)}
      data-testid={`readOnly-${name}`}
    >
      <Label
        tooltip={tooltip}
        tooltipPosition={tooltipPosition}
        className={styles.label}
        tooltipLabel={tooltipLabel}
        tooltipClassName={tooltipClassName}
      >
        {label}
      </Label>
      <div className={inputCss}>
        <span className={styles.value}>
          {errorMessage && (
            <Asset
              className={styles.error}
              icon={WarningIcon}
              height={14}
              width={14}
              description="error icon"
            />
          )}
          {displayValue}
        </span>
      </div>
    </div>
  );
};
